import {
  CalendarEvent,
  WeekViewTimeEvent,
  WeekViewHour,
  WeekViewHourSegment,
  validateEvents as validateEventsWithoutLog,
  ViewPeriod,
  WeekDay,
  WeekViewAllDayEvent,
} from 'calendar-utils';
import { DateAdapter } from 'angular-calendar/date-adapters/date-adapter';

export const validateEvents = (events: CalendarEvent[]) => {
  const warn = (...args) => console.warn('angular-calendar', ...args);
  return validateEventsWithoutLog(events, warn);
};

export function isInside(outer: ClientRect, inner: ClientRect): boolean {
  return (
    Math.floor(outer.left) <= Math.ceil(inner.left) &&
    Math.floor(inner.left) <= Math.ceil(outer.right) &&
    Math.floor(outer.left) <= Math.ceil(inner.right) &&
    Math.floor(inner.right) <= Math.ceil(outer.right) &&
    Math.floor(outer.top) <= Math.ceil(inner.top) &&
    Math.floor(inner.top) <= Math.ceil(outer.bottom) &&
    Math.floor(outer.top) <= Math.ceil(inner.bottom) &&
    Math.floor(inner.bottom) <= Math.ceil(outer.bottom)
  );
}

export function roundToNearest(amount: number, precision: number) {
  return Math.round(amount / precision) * precision;
}

export const trackByEventId = (index: number, event: CalendarEvent) =>
  event.id ? event.id : event;

export const trackByWeekDayHeaderDate = (index: number, day: WeekDay) =>
  day.date.toISOString();

export const trackByHourSegment = (
  index: number,
  segment: WeekViewHourSegment
) => segment.date.toISOString();

export const trackByHour = (index: number, hour: WeekViewHour) =>
  hour.segments[0].date.toISOString();

export const trackByWeekAllDayEvent = (
  index: number,
  weekEvent: WeekViewAllDayEvent
) => (weekEvent.event.id ? weekEvent.event.id : weekEvent.event);

export const trackByWeekTimeEvent = (
  index: number,
  weekEvent: WeekViewTimeEvent
) => (weekEvent.event.id ? weekEvent.event.id : weekEvent.event);

const MINUTES_IN_HOUR = 60;

function getPixelAmountInMinutes(
  hourSegments: number,
  hourSegmentHeight: number
) {
  return MINUTES_IN_HOUR / (hourSegments * hourSegmentHeight);
}

export function getMinutesMoved(
  movedY: number,
  hourSegments: number,
  hourSegmentHeight: number,
  eventSnapSize: number
): number {
  const draggedInPixelsSnapSize = roundToNearest(
    movedY,
    eventSnapSize || hourSegmentHeight
  );
  const pixelAmountInMinutes = getPixelAmountInMinutes(
    hourSegments,
    hourSegmentHeight
  );
  return draggedInPixelsSnapSize * pixelAmountInMinutes;
}

export function getMinimumEventHeightInMinutes(
  hourSegments: number,
  hourSegmentHeight: number
) {
  return (
    getPixelAmountInMinutes(hourSegments, hourSegmentHeight) * hourSegmentHeight
  );
}

export function getDefaultEventEnd(
  dateAdapter: DateAdapter,
  event: CalendarEvent,
  minimumMinutes: number
): Date {
  if (event.end) {
    return event.end;
  } else {
    return dateAdapter.addMinutes(event.start, minimumMinutes);
  }
}

export function addDaysWithExclusions(
  dateAdapter: DateAdapter,
  date: Date,
  days: number,
  excluded: number[]
): Date {
  let daysCounter = 0;
  let daysToAdd = 0;
  const changeDays = days < 0 ? dateAdapter.subDays : dateAdapter.addDays;
  let result = date;
  while (daysToAdd <= Math.abs(days)) {
    result = changeDays(date, daysCounter);
    const day = dateAdapter.getDay(result);
    if (excluded.indexOf(day) === -1) {
      daysToAdd++;
    }
    daysCounter++;
  }
  return result;
}

export function isDraggedWithinPeriod(
  newStart: Date,
  newEnd: Date,
  period: ViewPeriod
): boolean {
  const end = newEnd || newStart;
  return (
    (period.start <= newStart && newStart <= period.end) ||
    (period.start <= end && end <= period.end)
  );
}

export function shouldFireDroppedEvent(
  dropEvent: { dropData?: { event?: CalendarEvent; calendarId?: symbol } },
  date: Date,
  allDay: boolean,
  calendarId: symbol
) {
  return (
    dropEvent.dropData &&
    dropEvent.dropData.event &&
    (dropEvent.dropData.calendarId !== calendarId ||
      (dropEvent.dropData.event.allDay && !allDay) ||
      (!dropEvent.dropData.event.allDay && allDay))
  );
}

export function getWeekViewPeriod(
  dateAdapter: DateAdapter,
  viewDate: Date,
  weekStartsOn: number,
  excluded: number[] = [],
  daysInWeek?: number
): { viewStart: Date; viewEnd: Date } {
  let viewStart = daysInWeek
    ? dateAdapter.startOfDay(viewDate)
    : dateAdapter.startOfWeek(viewDate, { weekStartsOn });
  const endOfWeek = dateAdapter.endOfWeek(viewDate, { weekStartsOn });
  while (
    excluded.indexOf(dateAdapter.getDay(viewStart)) > -1 &&
    viewStart < endOfWeek
  ) {
    viewStart = dateAdapter.addDays(viewStart, 1);
  }
  if (daysInWeek) {
    const viewEnd = dateAdapter.endOfDay(
      addDaysWithExclusions(dateAdapter, viewStart, daysInWeek - 1, excluded)
    );
    return { viewStart, viewEnd };
  } else {
    let viewEnd = endOfWeek;
    while (
      excluded.indexOf(dateAdapter.getDay(viewEnd)) > -1 &&
      viewEnd > viewStart
    ) {
      viewEnd = dateAdapter.subDays(viewEnd, 1);
    }
    return { viewStart, viewEnd };
  }
}

export function isWithinThreshold({ x, y }: { x: number; y: number }) {
  const DRAG_THRESHOLD = 1;
  return Math.abs(x) > DRAG_THRESHOLD || Math.abs(y) > DRAG_THRESHOLD;
}

import * as g from '../../../../globals';
import * as moment from 'moment';
export function AtcivityRecordModel(date: Date, takeTime = false) {
  const recordModel = {
    ObjectCode: '33',
    ObjectKey: 'oContacts',
    ModuleApp: null,
    EventType: 0,
    KeyName: 'ClgCode',
    KeyValue: '',
    TableName: null,
    OnlinePayToken: null,
    BaseUrl: null,
    BaseCreationUrl: null,
    CreationToken: null,
    App: null,
    Language: null,
    LinesToDelete: '',
    Categories: [
      {
        Id: 'Contacts',
        Lines: [
          {
            Id: 0,
            Properties: [
              {
                Name: 'Recontact',
                Value: '01.06.22',
                ValueChanged: false,
                ValueAsObject: '2022-06-01T00:00:00',
                DBValue: '',
                FieldName: 'Recontact',
                EmptyValue: '',
                EscapedValue: null,
                AdditionalInformation: null,
                AdditionalInformationModel: {
                  SAPFSControl: null
                },
                Escape: false,
                Disabled: false,
                IsHTML: false,
                DataType: 5,
                Options: [],
                FieldId: 66,
                ReadOnly: false,
                ExecuteParentChangeOnLoad: false,
                Initialized: false
              },
              {
                Name: 'Closed',
                Value: 'N',
                ValueChanged: false,
                ValueAsObject: 'N',
                DBValue: '',
                FieldName: 'Closed',
                EmptyValue: '',
                EscapedValue: null,
                AdditionalInformation: null,
                AdditionalInformationModel: {
                  SAPFSControl: null
                },
                Escape: false,
                Disabled: false,
                IsHTML: false,
                DataType: 3,
                Options: [
                  {
                    Code: 'N',
                    DBValue: 'N',
                    Name: 'No'
                  }
                ],
                FieldId: 56,
                ReadOnly: false,
                ExecuteParentChangeOnLoad: false,
                Initialized: false
              },
              {
                Name: 'Activity',
                Value: 'C',
                ValueChanged: false,
                ValueAsObject: 'C',
                DBValue: '',
                FieldName: 'Action',
                EmptyValue: '',
                EscapedValue: null,
                AdditionalInformation: null,
                AdditionalInformationModel: {
                  SAPFSControl: null
                },
                Escape: false,
                Disabled: false,
                IsHTML: false,
                DataType: 3,
                Options: [
                  {
                    Code: 'C',
                    DBValue: 'C',
                    Name: 'Phone Call'
                  }
                ],
                FieldId: 47,
                ReadOnly: false,
                ExecuteParentChangeOnLoad: false,
                Initialized: false
              },
              {
                Name: 'ActivityType',
                Value: '-1',
                ValueChanged: false,
                ValueAsObject: -1,
                DBValue: '',
                FieldName: 'CntctType',
                EmptyValue: '',
                EscapedValue: null,
                AdditionalInformation: null,
                AdditionalInformationModel: {
                  SAPFSControl: null
                },
                Escape: false,
                Disabled: false,
                IsHTML: false,
                DataType: 3,
                Options: [
                  {
                    Code: '-1',
                    DBValue: '-1',
                    Name: 'Allgemein'
                  }
                ],
                FieldId: 48,
                ReadOnly: false,
                ExecuteParentChangeOnLoad: false,
                Initialized: false
              }, {
                Name: 'AssignedBy',
                Value: '1',
                ValueChanged: false,
                ValueAsObject: 1,
                DBValue: '',
                FieldName: 'AssignedBy',
                EmptyValue: '',
                EscapedValue: null,
                AdditionalInformation: null,
                AdditionalInformationModel: {
                  SAPFSControl: null
                },
                Escape: false,
                Disabled: true,
                IsHTML: false,
                DataType: 3,
                Options: [
                  {
                    Code: '1',
                    DBValue: '1',
                    Name: 'Daniel Maurer'
                  }
                ],
                FieldId: 6169,
                ReadOnly: true,
                ExecuteParentChangeOnLoad: false,
                Initialized: false
              },
              {
                Name: 'StartTime',
                Value: '16:23',
                ValueChanged: false,
                ValueAsObject: '1990-01-01T16:23:00',
                DBValue: '',
                FieldName: 'BeginTime',
                EmptyValue: '',
                EscapedValue: null,
                AdditionalInformation: null,
                AdditionalInformationModel: {
                  SAPFSControl: null
                },
                Escape: false,
                Disabled: false,
                IsHTML: false,
                DataType: 6,
                Options: [],
                FieldId: 67,
                ReadOnly: false,
                ExecuteParentChangeOnLoad: false,
                Initialized: false
              },
              {
                Name: 'HandledBy',
                Value: '1',
                ValueChanged: false,
                ValueAsObject: 1,
                DBValue: '',
                FieldName: 'AttendUser',
                EmptyValue: '',
                EscapedValue: null,
                AdditionalInformation: null,
                AdditionalInformationModel: {
                  SAPFSControl: null
                },
                Escape: false,
                Disabled: false,
                IsHTML: false,
                DataType: 3,
                Options: [
                  {
                    Code: '1',
                    DBValue: '1',
                    Name: 'Daniel Maurer'
                  }
                ],
                FieldId: 65,
                ReadOnly: false,
                ExecuteParentChangeOnLoad: false,
                Initialized: false
              },
              {
                Name: 'Reminder',
                Value: 'N',
                ValueChanged: false,
                ValueAsObject: 'N',
                DBValue: '',
                FieldName: 'Reminder',
                EmptyValue: '',
                EscapedValue: null,
                AdditionalInformation: null,
                AdditionalInformationModel: {
                  SAPFSControl: null
                },
                Escape: false,
                Disabled: false,
                IsHTML: false,
                DataType: 3,
                Options: [
                  {
                    Code: 'N',
                    DBValue: 'N',
                    Name: 'No'
                  }
                ],
                FieldId: 10481,
                ReadOnly: false,
                ExecuteParentChangeOnLoad: false,
                Initialized: false
              },
              {
                Name: 'U_ITM_BWEB_READ',
                Value: 'N',
                ValueChanged: false,
                ValueAsObject: 'N',
                DBValue: '',
                FieldName: 'U_ITM_BWEB_READ',
                EmptyValue: '',
                EscapedValue: null,
                AdditionalInformation: null,
                AdditionalInformationModel: {
                  SAPFSControl: null
                },
                Escape: false,
                Disabled: true,
                IsHTML: false,
                DataType: 3,
                Options: [
                  {
                    Code: 'N',
                    DBValue: 'N',
                    Name: 'No'
                  }
                ],
                FieldId: 10323,
                ReadOnly: true,
                ExecuteParentChangeOnLoad: false,
                Initialized: false
              },
              {
                Name: 'Priority',
                Value: '1',
                ValueChanged: false,
                ValueAsObject: '1',
                DBValue: '',
                FieldName: 'Priority',
                EmptyValue: '',
                EscapedValue: null,
                AdditionalInformation: null,
                AdditionalInformationModel: {
                  SAPFSControl: null
                },
                Escape: false,
                Disabled: false,
                IsHTML: false,
                DataType: 3,
                Options: [
                  {
                    Code: '1',
                    DBValue: '1',
                    Name: 'Normal'
                  }
                ],
                FieldId: 61,
                ReadOnly: false,
                ExecuteParentChangeOnLoad: false,
                Initialized: false
              },
            ],
            Visible: true
          }
        ],
        DeletedLines: [],
        SpecialLines: null,
        LineToDelete: null,
        KeyFieldName: null,
        KeyPropertyName: null,
        PropertyNameInParent: null,
        AdditionalIdentifier: null,
        AlwaysHasDefaultValue: false,
        Disabled: false,
        MaxIndex: 0
      },
    ],
    UnkownKeys: [],
    ModuleId: 25,
    ObjectTypeValue: '33',
    FormGUID: '',
    FromDraft: false,
    ModuleType: 2,
    UpdateMethodName: 'Update',
    CreateMethodName: 'Add',
    RemoveMethodName: 'Remove',
    IsPublic: false,
    LastBatchNumber: '',
    KeyValues: null
  };

  const strtDate = recordModel.Categories.find(x => x.Id === 'Contacts')
    .Lines[0].Properties.find(x => x.Name === 'Recontact');
  const startTime = recordModel.Categories.find(x => x.Id === 'Contacts').Lines[0]
    .Properties.find(x => x.Name === 'StartTime');
  if (!takeTime) {
    const nowDate = new Date();
    startTime.Value = nowDate.toLocaleTimeString();
    startTime.ValueAsObject = moment(nowDate).format('YYYY-MM-DDTHH:mm:ss');
  }
  else {
    startTime.Value = date.toISOString();
    startTime.ValueAsObject = date.toISOString();
  }
  strtDate.ValueAsObject = moment(date).format('YYYY-MM-DDTHH:mm:ss');
  strtDate.Value = g.FormatDate(date);

  const userId = g.userIdentity.UserSign;
  const assignedBy = recordModel.Categories.find(x => x.Id === 'Contacts')
    .Lines[0].Properties.find(x => x.Name === 'AssignedBy');
  const handeledBy = recordModel.Categories.find(x => x.Id === 'Contacts')
    .Lines[0].Properties.find(x => x.Name === 'HandledBy');
  assignedBy.Value = handeledBy.Value = `${userId}`;
  assignedBy.ValueAsObject = handeledBy.ValueAsObject = userId;
  return recordModel;
}
